import { storage } from '@shared/utils/storage'
import { DataReceiveService } from './data'

export const StorageService = DataReceiveService.extend({
  key: null,
  storage: storage,
  storageParams: {},

  created() {
    this.validate()
    this.restoreFromCache()
  },

  methods: {
    validate() {
      if (this.$options.key === null) {
        throw new Error('You must provide key for your service storage.')
      }
    },

    restoreFromCache() {
      let data = this.$options.storage.getItem(this.$options.key)

      if (data != null) {
        for (let key in data) {
          this.$set(this, key, data[key])
        }
      }
    },

    getStorageParams() {
      return this.$options.storageParams
    },

    updateCache() {
      // this.$options.storage.setItem(
      //   this.$options.key, this._data, this.getStorageParams()
      // )
    },

    exists(collection, key) {
      let map = this[collection]

      return typeof map[key] !== 'undefined' && !!map[key]
    },

    setCollection(collection, data) {
      this.$set(this, collection, data)

      this.updateCache()
      this.$emit('updateCollection', { collection, data })
      this.$emit(`update${collection.toTitle()}`, { data })
    },

    retreiveCollection(url, collection) {
      let obj = this[collection]
      let isObject = obj.constructor === Object

      if (
        (isObject && Object.keys(obj) > 0) ||
        (!isObject && !!obj)
      ) {
        return new Promise(resolve => resolve(this[collection]))
      } else {
        return this.getData(url, data => {
          this.setCollection(collection, data)
        })
      }
    },

    setCollectionItem(collection, id, data) {
      this[collection][id] = data

      this.updateCache()
      this.$emit('updateCollectionItem', { collection, id, data })
      this.$emit(`update${collection.toTitle()}Item`, { id, data })
    },

    retreiveCollectionItem(url, collection, id) {
      if (this.exists(collection, id)) {
        return new Promise(resolve => resolve(this[collection][id]))
      } else {
        return this.getData(url, data => {
          this.setCollectionItem(collection, id, data)
        })
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/js/shared/services/storage.js